import cn from 'classnames';

interface IContentWithSidebarProps {
  children: React.ReactNode;
  className?: string;
}

const ContentWithSidebarHeader: React.FC<IContentWithSidebarProps> = ({ className, children }) => {
  if (!children) return null;

  return <div className={cn('content-with-sidebar--header', className)}>{children}</div>;
};

ContentWithSidebarHeader.displayName = 'ContentWithSidebarHeader';

export default ContentWithSidebarHeader;
